import { ComposableTypography } from '@bcp-nextgen-dx-component-factory/design-system';

import { useDisplayCostHelper } from './displayCost.helper';
import { DisplayCostAppearance } from './displayCost.settings';

interface DisplayCostProps {
	cost: number | string;
	appearance: DisplayCostAppearance;
}

export const DisplayCost: React.FC<DisplayCostProps> = ({ cost, appearance }) => {
	const { costText, costAppearance, currencyAppearance, frequencyAppearance } = useDisplayCostHelper(
		cost,
		appearance
	);

	return (
		<div style={{ textDecoration: appearance === 'secondary' ? 'line-through' : 'unset' }}>
			<ComposableTypography
				text={costText}
				baseProps={costAppearance}
				tags={{
					currency: currencyAppearance,
					frequency: frequencyAppearance,
				}}
			/>
		</div>
	);
};
